import TRANSCODING_STATUSES from './transcoding-statuses';

const { IN_QUEUE, INPROGRESS, PREVIEW_READY, READY, FAILED } = TRANSCODING_STATUSES;

export default {
  DOWNLOADING: 'DOWNLOADING',
  UPLOADING: 'UPLOADING',
  IN_STORAGE: 'IN-STORAGE',
  IN_QUEUE,
  INPROGRESS,
  PREVIEW_READY,
  READY,
  FAILED,
};




// WEBPACK FOOTER //
// ./src/shared/constants/async-uploading-statuses.js